import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateTicket,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [checklistItems, setChecklistItems] = useState([]);
  const [pendingIssues, setPendingIssues] = useState([]);

  useEffect(() => {
    if (!select_data) return;

    const selectedVehicle = vehicles.find(
      (vehicle) => vehicle.numberplate === select_data.vehicle_number,
    );

    setUpdate_modal_data({
      ...select_data,

      vehicle_id:
        select_data.vehicle_id?._id ||
        select_data.vehicle_id ||
        selectedVehicle?._id ||
        "",

      vehicle_number:
        select_data.vehicle_number || selectedVehicle?.numberplate || "",

      assigned_to:
        select_data.assigned_to?._id || select_data.assigned_to || "",

      driver_id: select_data.driver_id?._id || select_data.driver_id || "",

      dates: {
        ...select_data.dates,
        ticket_issued: select_data.dates?.ticket_issued || "",
        tentative_date: select_data.dates?.tentative_date || "",
      },

      category: select_data.category?._id || select_data.category || "",

      checklist: Array.isArray(select_data.checklist)
        ? select_data.checklist
        : [],
      pendingissue: select_data.pendingissue || "",
      comments: "",
    });
  }, [select_data, vehicles]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUsers(response.data.users || []);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    const fetchPendingIssues = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v2/vehicle-tickets`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        const tickets = Array.isArray(response.data?.tickets)
          ? response.data.tickets
          : [];

        const issueMap = new Map();

        tickets.forEach((ticket) => {
          const pendingIssue = ticket?.pendingissue;

          if (typeof pendingIssue === "string" && pendingIssue.trim() !== "") {
            const issue = pendingIssue.trim();
            const key = issue.toLowerCase();

            if (!issueMap.has(key)) {
              issueMap.set(key, {
                value: issue,
                label: issue,
              });
            }
          }
        });

        setPendingIssues(Array.from(issueMap.values()));
      } catch (error) {
        console.error("Error fetching pending issues:", error);
        setPendingIssues([]);
      }
    };

    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v4/vehicle-ticket-category`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setCategories(response.data.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
        setCategories([]);
      }
    };

    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setVehicles(response.data.vehicles || []);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    const fetchChecklist = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/vehicle-defects`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (Array.isArray(response.data.defects)) {
          setChecklistItems(response.data.defects);
        } else {
          setChecklistItems([]);
        }
      } catch (error) {
        console.error("Error fetching checklist:", error);
        setChecklistItems([]);
      }
    };
    fetchChecklist();
    fetchCategories();
    fetchUsers();
    fetchVehicles();
    fetchPendingIssues();
  }, []);
  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      category: value,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "vehicle_number") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        vehicle_number: { ...prevData.vehicle_number, [name]: value },
      }));
    } else if (name === "category") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        category: { ...prevData.id_category, [name]: value },
      }));
    } else if (name === "assigned_to") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        assigned_to: { ...prevData.assigned_to, [name]: value },
      }));
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };

  const handleUserChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      assigned_to: value,
    }));
  };

  const handleVehicleChange = (e) => {
    const selectedVehicleId = e.target.value; // Get the selected vehicle ID
    const selectedVehicle = vehicles.find(
      (vehicle) => vehicle._id === selectedVehicleId,
    );
    if (selectedVehicle) {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        vehicle_number: selectedVehicle.numberplate, // Set the numberplate instead of the ID
      }));
    }
  };

  const driverOptions = users.map((user) => ({
    value: user._id,
    label: `${user.name || "Unknown Name"} ${
      user.phonenumber ? `(${user.phonenumber})` : ""
    }`,
  }));

  const selectedDriver =
    driverOptions.find(
      (option) => option.value === update_modal_data.driver_id,
    ) || null;

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.assigned_to)
      newErrors.assigned_to = "Assigned ID is required";
    if (!update_modal_data.status) newErrors.status = "Status is required";

    if (!update_modal_data.vehicle_number) {
      errors.vehicle_number = "Vehicle is required";
    }
    if (!update_modal_data.heading) {
      errors.heading = "Heading is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();

          // Vehicle
          if (update_modal_data.vehicle_id) {
            formData.append("vehicle_id", update_modal_data.vehicle_id);
          }

          // Driver
          if (update_modal_data.driver_id) {
            formData.append("driver_id", update_modal_data.driver_id);
          } else {
            // Send empty value if driver was cleared
            formData.append("driver_id", "");
          }
          formData.append("assigned_to", update_modal_data.assigned_to);

          formData.append("status", update_modal_data.status);
          formData.append("description", update_modal_data.description);
          formData.append("heading", update_modal_data.heading);
          formData.append(
            "ticket_issued",
            update_modal_data.dates?.ticket_issued || "",
          );
          formData.append(
            "tentative_date",
            update_modal_data.dates?.tentative_date || "",
          );
          if (update_modal_data.category) {
            formData.append("category", update_modal_data.category);
          }
          formData.append(
            "checklist",
            JSON.stringify(update_modal_data.checklist || []),
          );

          formData.append("pendingissue", update_modal_data.pendingissue || "");
          // formData.append("comments", update_modal_data.comments);
          formData.append(
            "comments",
            Array.isArray(update_modal_data.comments)
              ? JSON.stringify(update_modal_data.comments)
              : update_modal_data.comments,
          );

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v2/vehicle-ticket/${_id}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateTicket(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
          console.error("Error updating ticket:", error);
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const userOptions = users.map((user) => ({
    value: user._id,
    label: `${user.name || "Unknown Name"} (${
      user.phonenumber || "Unknown Phone"
    })`,
  }));

  const vehicleOptions = vehicles.map((vehicle) => ({
    value: vehicle._id,
    label: vehicle.numberplate,
  }));

  const categoryOptions = categories.map((category) => ({
    value: category._id,
    label: category.name,
  }));

  const selectedUser =
    userOptions.find(
      (option) => option.value === update_modal_data.assigned_to,
    ) || null;

  const selectedVehicle =
    vehicleOptions.find(
      (option) => option.value === update_modal_data.vehicle_id,
    ) || null;

  const selectedCategory =
    categoryOptions.find(
      (option) => option.value === update_modal_data.category,
    ) || null;

  const selectedPendingIssue =
    pendingIssues.find(
      (option) =>
        option.value?.toLowerCase() ===
        update_modal_data.pendingissue?.toLowerCase(),
    ) ||
    (update_modal_data.pendingissue
      ? {
          value: update_modal_data.pendingissue,
          label: update_modal_data.pendingissue,
        }
      : null);

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Ticket Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="assigned_to">
              <Form.Label>User *</Form.Label>
              {/* <Form.Control
                as="select"
                name="assigned_to"
                value={update_modal_data.assigned_to || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.assigned_to}
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name || "Unknown Name"} (
                    {user.phonenumber || "Unknown Phone"} )
                  </option>
                ))}
              </Form.Control> */}
              <Select
                options={userOptions}
                value={selectedUser}
                onChange={(selectedOption) => {
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    assigned_to: selectedOption ? selectedOption.value : "",
                  }));
                }}
                placeholder="Search User..."
                isSearchable
                isClearable
                noOptionsMessage={() => "No user found"}
                className={errors.assigned_to ? "is-invalid" : ""}
              />
              <Form.Control.Feedback type="invalid">
                {errors.assigned_to}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="id_client">
              <Form.Label>Vehicle *</Form.Label>
              {/* <Form.Control
                as="select"
                name="vehicle_number"
                // value={update_modal_data.vehicle_number || ""}
                value={
                  vehicles.find(
                    (vehicle) =>
                      vehicle.numberplate === update_modal_data.vehicle_number,
                  )?._id || ""
                }
                onChange={handleVehicleChange}
                isInvalid={!!errors.vehicle_number}
              >
                <option value="">Select Vehicle</option>
                {vehicles.map((vehicle) => (
                  <option key={vehicle._id} value={vehicle._id}>
                    {vehicle.numberplate}
                  </option>
                ))}
              </Form.Control> */}
              <Select
                options={vehicleOptions}
                value={selectedVehicle}
                onChange={(selectedOption) => {
                  const selectedVehicle = vehicles.find(
                    (vehicle) => vehicle._id === selectedOption?.value,
                  );

                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    vehicle_id: selectedVehicle?._id || "",
                    vehicle_number: selectedVehicle?.numberplate || "",
                  }));
                }}
                placeholder="Search Vehicle..."
                isSearchable
                isClearable
                noOptionsMessage={() => "No vehicle found"}
                className={errors.vehicle_number ? "is-invalid" : ""}
              />
              <Form.Control.Feedback type="invalid">
                {errors.vehicle_number}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Driver</Form.Label>

              <Select
                options={driverOptions}
                value={selectedDriver}
                onChange={(selectedOption) => {
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    driver_id: selectedOption?.value || "",
                  }));
                }}
                placeholder="Search Driver..."
                isSearchable
                isClearable
                noOptionsMessage={() => "No driver found"}
              />
            </Form.Group>

            {/* <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Category *</Form.Label>
              <Form.Control
                as="select"
                name="category"
                value={update_modal_data.category || ""}
                onChange={handleCategoryChange}
                isInvalid={!!errors.category}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group> */}
            <Form.Group className="mb-3" controlId="id_user">
              <Form.Label>Category *</Form.Label>
              {/* <Form.Select
                name="category"
                value={update_modal_data.category || ""}
                onChange={handleCategoryChange}
                isInvalid={!!errors.category}
              >
                <option value="">Select Category</option>
                {categories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </Form.Select> */}
              <Select
                options={categoryOptions}
                value={selectedCategory}
                onChange={(selectedOption) => {
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    category: selectedOption ? selectedOption.value : "",
                  }));
                }}
                placeholder="Search Category..."
                isSearchable
                isClearable
                noOptionsMessage={() => "No category found"}
                className={errors.category ? "is-invalid" : ""}
              />
              <Form.Control.Feedback type="invalid">
                {errors.category}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Checklist</Form.Label>

              <Select
                isMulti
                isSearchable
                placeholder="Select checklist items..."
                options={checklistItems.map((item) => ({
                  value: item._id,
                  label: item.defectName,
                }))}
                value={checklistItems
                  .filter((item) =>
                    update_modal_data.checklist?.includes(item.defectName),
                  )
                  .map((item) => ({
                    value: item._id,
                    label: item.defectName,
                  }))}
                onChange={(selectedOptions) => {
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    checklist: selectedOptions
                      ? selectedOptions.map((option) => option.label)
                      : [],
                  }));
                }}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isClearable
                noOptionsMessage={() => "No checklist items found"}
                classNamePrefix="checklist-select"
                components={{
                  Option: (props) => {
                    const { data, isSelected } = props;

                    return (
                      <components.Option {...props}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            width: "100%",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                          />

                          <span>{data.label}</span>
                        </div>
                      </components.Option>
                    );
                  },

                  MenuList: (props) => {
                    return (
                      <components.MenuList {...props}>
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "0",
                          }}
                        >
                          {props.children}
                        </div>
                      </components.MenuList>
                    );
                  },
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Pending Issue</Form.Label>

              <CreatableSelect
                options={pendingIssues}
                value={selectedPendingIssue}
                placeholder="Select or Add Pending Issue"
                onChange={(option) => {
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    pendingissue: option?.value || "",
                  }));
                }}
                onCreateOption={(inputValue) => {
                  const trimmedValue = inputValue.trim();

                  if (!trimmedValue) return;

                  const newIssue = {
                    value: trimmedValue,
                    label: trimmedValue,
                  };

                  setPendingIssues((prev) => {
                    const exists = prev.some(
                      (item) =>
                        item.value?.toLowerCase() ===
                        trimmedValue.toLowerCase(),
                    );

                    if (exists) return prev;

                    return [...prev, newIssue];
                  });

                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    pendingissue: trimmedValue,
                  }));
                }}
                isClearable
                isSearchable
                classNamePrefix="select"
                noOptionsMessage={() => "No pending issues found"}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={update_modal_data.status || ""}
                onChange={handleChange}
                isInvalid={!!errors.status}
              >
                <option value="In-Progress">In-Progress</option>
                <option value="Todo">Todo</option>
                <option value="Done">Done</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.status}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Heading </Form.Label>
              <Form.Control
                type="text"
                name="heading"
                value={update_modal_data.heading || ""}
                onChange={handleChange}
                isInvalid={!!errors.heading}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Issue Date</Form.Label>
              <Form.Control
                type="date"
                name="ticket_issued"
                value={
                  update_modal_data.dates?.ticket_issued
                    ? new Date(update_modal_data.dates.ticket_issued)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    dates: {
                      ...prevData.dates,
                      ticket_issued: e.target.value,
                    },
                  }))
                }
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Tentative Date</Form.Label>
              <Form.Control
                type="date"
                name="tentative_date"
                value={
                  update_modal_data.dates?.tentative_date
                    ? new Date(update_modal_data.dates.tentative_date)
                        .toISOString()
                        .split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setUpdate_modal_data((prevData) => ({
                    ...prevData,
                    dates: {
                      ...prevData.dates,
                      tentative_date: e.target.value,
                    },
                  }))
                }
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description </Form.Label>
              <Form.Control
                type="text"
                name="description"
                value={update_modal_data.description || ""}
                onChange={handleChange}
                isInvalid={!!errors.description}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Comments *</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="comments"
                value={
                  Array.isArray(update_modal_data.comments)
                    ? update_modal_data.comments.map((c) => c.text).join("\n")
                    : update_modal_data.comments || ""
                }
                onChange={handleChange}
                placeholder="Enter comments"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Ticket
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
